// IA para Torneo de Artes Marciales - 11 estilos con dificultad progresiva
export const MartialStyles = [
  {
    id: 'kravmaga',
    name: 'KRAV MAGA',
    folder: 'krav maga',
    music: 'kravmaga.mp3',
    health: 90,
    damage: { hand: 9, foot: 13 },
    speed: { min: 0.008, max: 0.014 },
    attackInterval: { min: 4000, max: 6000 },
    attackChance: 0.30,
    blockChance: 0.15,
    grabChance: 0.08,
    grabDamage: 15,
    grabEscapeTime: 3000,
    xpReward: 8
  },
  {
    id: 'capoeira',
    name: 'CAPOEIRA',
    folder: 'capoeira',
    music: 'capoeira.mp3',
    health: 95,
    damage: { hand: 8, foot: 15 },
    speed: { min: 0.012, max: 0.020 },
    attackInterval: { min: 3500, max: 5500 },
    attackChance: 0.35,
    blockChance: 0.18,
    grabChance: 0.10,
    grabDamage: 16,
    grabEscapeTime: 2800,
    xpReward: 10
  },
  {
    id: 'box',
    name: 'BOX',
    folder: 'box',
    music: 'box.mp3',
    health: 110,
    damage: { hand: 12, foot: 8 },
    speed: { min: 0.012, max: 0.018 },
    attackInterval: { min: 3000, max: 5000 },
    attackChance: 0.40,
    blockChance: 0.25,
    grabChance: 0.12,
    grabDamage: 18,
    grabEscapeTime: 2700,
    xpReward: 12
  },
  {
    id: 'sipalki',
    name: 'SIPALKI',
    folder: 'sipalki',
    music: 'sipalki.mp3',
    health: 115,
    damage: { hand: 11, foot: 14 },
    speed: { min: 0.014, max: 0.020 },
    attackInterval: { min: 2800, max: 4500 },
    attackChance: 0.42,
    blockChance: 0.28,
    grabChance: 0.14,
    grabDamage: 19,
    grabEscapeTime: 2600,
    xpReward: 14
  },
  {
    id: 'kungfu',
    name: 'KUNG FU',
    folder: 'kunfu',
    music: 'kungfu.mp3',
    health: 120,
    damage: { hand: 13, foot: 16 },
    speed: { min: 0.015, max: 0.022 },
    attackInterval: { min: 2500, max: 4000 },
    attackChance: 0.45,
    blockChance: 0.30,
    grabChance: 0.15,
    grabDamage: 20,
    grabEscapeTime: 2500,
    xpReward: 16
  },
  {
    id: 'karate',
    name: 'KARATE',
    folder: 'karate',
    music: 'karate.mp3',
    health: 130,
    damage: { hand: 14, foot: 18 },
    speed: { min: 0.016, max: 0.024 },
    attackInterval: { min: 2300, max: 3800 },
    attackChance: 0.50,
    blockChance: 0.35,
    grabChance: 0.16,
    grabDamage: 21,
    grabEscapeTime: 2400,
    xpReward: 18
  },
  {
    id: 'kickboxing',
    name: 'KICKBOXING',
    folder: 'kickboxing',
    music: 'kickboxing.mp3',
    health: 140,
    damage: { hand: 15, foot: 20 },
    speed: { min: 0.018, max: 0.026 },
    attackInterval: { min: 2000, max: 3500 },
    attackChance: 0.55,
    blockChance: 0.38,
    grabChance: 0.18,
    grabDamage: 22,
    grabEscapeTime: 2300,
    xpReward: 20
  },
  {
    id: 'mma',
    name: 'MMA',
    folder: 'mma',
    music: 'mma.mp3',
    health: 130,
    damage: { hand: 14, foot: 18 },
    speed: { min: 0.012, max: 0.020 },
    attackInterval: { min: 2500, max: 4000 },
    attackChance: 0.50,
    blockChance: 0.30,
    grabChance: 0.18,
    grabDamage: 20,
    grabEscapeTime: 2500,
    xpReward: 22
  },
  {
    id: 'muaythai',
    name: 'MUAY THAI',
    folder: 'muaythai',
    music: 'muaythai.mp3',
    health: 140,
    damage: { hand: 15, foot: 20 },
    speed: { min: 0.014, max: 0.022 },
    attackInterval: { min: 2200, max: 3800 },
    attackChance: 0.55,
    blockChance: 0.32,
    grabChance: 0.20,
    grabDamage: 22,
    grabEscapeTime: 2400,
    xpReward: 25
  },
  {
    id: 'sumo',
    name: 'SUMO',
    folder: 'sumo',
    music: 'sumo.mp3',
    health: 155,
    damage: { hand: 16, foot: 13 },
    speed: { min: 0.006, max: 0.012 },
    attackInterval: { min: 2500, max: 4000 },
    attackChance: 0.45,
    blockChance: 0.35,
    grabChance: 0.25,
    grabDamage: 25,
    grabEscapeTime: 2300,
    xpReward: 28
  },
  {
    id: 'sambo',
    name: 'SAMBO',
    folder: 'sambo',
    music: 'sambo.mp3',
    health: 165,
    damage: { hand: 16, foot: 21 },
    speed: { min: 0.014, max: 0.022 },
    attackInterval: { min: 2000, max: 3500 },
    attackChance: 0.55,
    blockChance: 0.35,
    grabChance: 0.22,
    grabDamage: 24,
    grabEscapeTime: 2200,
    xpReward: 32
  }
];

export class MartialBehavior {
  constructor(styleIndex) {
    this.config = MartialStyles[styleIndex] || MartialStyles[0];
    this.lastAttackTime = 0;
    this.lastGrabTime = 0;
    this.lastBlockTime = 0;
    this.playerHitCount = 0;
    this.isInCombo = false;
    this.vulnerableUntil = 0; // después de atacar queda vulnerable
  }

  getMovementSpeed() {
    const { min, max } = this.config.speed;
    // Limitar velocidad máxima para que no se escape del rango
    const cappedMax = Math.min(max, 0.022);
    return min + Math.random() * (cappedMax - min);
  }

  getAggressiveness() {
    return this.config.attackChance;
  }

  shouldAttack(currentTime) {
    const timeSince = currentTime - this.lastAttackTime;
    const { min, max } = this.config.attackInterval;
    if (timeSince < min + Math.random() * (max - min)) return false;
    return Math.random() < this.config.attackChance;
  }

  selectAttackType() {
    const r = Math.random();
    if (r < 0.25) return 'punch1';
    if (r < 0.50) return 'punch2';
    if (r < 0.75) return 'kick1';
    return 'kick2';
  }

  shouldGrab(currentTime) {
    if (currentTime - this.lastGrabTime < 10000) return false;
    return Math.random() < this.config.grabChance;
  }

  shouldBlock(isPlayerAttacking) {
    if (!isPlayerAttacking) return false;
    const now = Date.now();
    // No puede bloquear si está vulnerable (post-ataque)
    if (now < this.vulnerableUntil) return false;
    // Cooldown entre bloqueos (mínimo 2s)
    if (now - this.lastBlockTime < 2000) return false;
    // Máximo 30% de bloqueo efectivo para que siempre se pueda pegar
    const effectiveBlock = Math.min(this.config.blockChance, 0.30);
    if (Math.random() < effectiveBlock) {
      this.lastBlockTime = now;
      return true;
    }
    return false;
  }

  shouldDodge() {
    const now = Date.now();
    if (now < this.vulnerableUntil) return false;
    return Math.random() < Math.min(this.config.blockChance * 0.3, 0.15);
  }

  onAttack(currentTime) {
    this.lastAttackTime = currentTime;
    // Después de atacar queda vulnerable 1.5s (no puede bloquear ni esquivar)
    this.vulnerableUntil = currentTime + 1500;
  }
  onGrab(currentTime) { this.lastGrabTime = currentTime; }
  onPlayerHit() { this.playerHitCount++; }
  resetPlayerHitCounter() { this.playerHitCount = 0; }

  getDamage(type) { return this.config.damage[type] || 10; }
  getInitialHealth() { return this.config.health; }
  getImageFolder() { return this.config.folder; }
}
